import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

/** Side taps page photos; a travelling pointer remains the parent's swipe. */
export function AlbumSideControls({ rtl, onMove }: { rtl: boolean; onMove: (step: -1 | 1) => void }) {
  const { t } = useTranslation();
  const pointer = useRef<{ x: number; y: number } | null>(null);
  const moved = useRef(false);
  return <>{(['left', 'right'] as const).map(side => {
    const step = (side === 'left' ? (rtl ? 1 : -1) : (rtl ? -1 : 1)) as -1 | 1;
    return <button key={side} type="button" aria-label={t(step === 1 ? 'common.next' : 'common.previous')}
      className="album-side-control" style={{ [side]: 0 }}
      onPointerDown={event => { pointer.current = { x: event.clientX, y: event.clientY }; moved.current = false; }}
      onPointerMove={event => { if (pointer.current && Math.hypot(event.clientX-pointer.current.x, event.clientY-pointer.current.y) > 12) moved.current = true; }}
      onPointerCancel={() => { moved.current = true; }}
      onClick={event => { event.stopPropagation(); if (!moved.current || event.detail === 0) onMove(step); pointer.current = null; }} />;
  })}</>;
}
